import { render } from "./DetailsInput.vue?vue&type=template&id=b737c9ba&scoped=true"
import script from "./DetailsInput.vue?vue&type=script&lang=js"
export * from "./DetailsInput.vue?vue&type=script&lang=js"

import "./DetailsInput.vue?vue&type=style&index=0&id=b737c9ba&lang=css&scoped=true"

import exportComponent from "/tmp/tmp.J0U5ZeTglF/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b737c9ba"]])

export default __exports__